import React from 'react';
import {
  Box,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useSearchParams } from 'react-router-dom';

const BenefitsContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(0.5),
  },
}));

const BenefitItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(1.5),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(1),
  },
}));

const CheckIconStyled = styled(CheckCircleOutlineIcon)(({ theme }) => ({
  color: theme.palette.success.main,
  marginRight: theme.spacing(1.5),
  fontSize: '1.25rem',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.125rem',
    marginRight: theme.spacing(1),
  },
}));

const BenefitsTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 700,
  fontSize: '1rem',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.9375rem',
    marginBottom: theme.spacing(1.5),
  },
}));

const BenefitText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
  lineHeight: 1.5,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.8125rem',
  },
}));

const BenefitsList: React.FC = () => {
  const theme = useTheme();
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [searchParams] = useSearchParams()
  const isAddOn = Boolean(searchParams.get("addOn"));
  const subscriptionBenefits = [
    'Support when you need it most',
    'Access to trained coaches',
    'Simple monthly subscription',
  ];
  const addonBenefits = [
    'Moments are the number of texts you send MindRight',
    'Unused Moments expire at the end of the active subscription bill cycle'
  ]

  const benefits = isAddOn ? addonBenefits : subscriptionBenefits

  return (
    <BenefitsContainer>
      {isAddOn ? <BenefitsTitle variant="h6">MindRight Add-On Benefits</BenefitsTitle> : <BenefitsTitle variant="h6">MindRight Benefits</BenefitsTitle>}
      {benefits.map((benefit, index) => (
        <BenefitItem key={index}>
          <CheckIconStyled fontSize="small" />
          <BenefitText>{benefit}</BenefitText>
        </BenefitItem>
      ))}
    {isSmallMobile && <Box sx={{ height: 20 }} />}
    </BenefitsContainer>
  );
};

export default BenefitsList;